module.exports = __webpack_public_path__ + "static/media/takmilchecklist.9542ad95.svg";